import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DialogContainerComponent } from '../dialog-container/dialog-container.component';
import { IOption } from '../../models/option.model';
import { UIElementsModule } from '../../ui-elements/ui-elements.module';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [
    CommonModule,
    DialogContainerComponent,
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    UIElementsModule,
  ],
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      entityName: string;
      message: string;
      warningMessage: string;
      list: string[];
      entityType: 'serviceReport' | 'correctiveAction';
      confirmButtonText: string;
      cancelButtonText: string;
      confirmButton: 'primary' | 'warn-secondary';
      showAreYouSure: boolean;
      content: TemplateRef<any>;
      ownPunctuationMark: boolean;
      messages?: string[];
      width?: string;
      choiceControl?: FormControl<number | null>;
      choiceOptions?: IOption[];
    }
  ) {
    this.data.title = this.data.title ?? this.translate.instant('delete');
    this.data.message = this.data.message ?? 'youAreDeleting';
    this.data.warningMessage = this.data.warningMessage ?? '';
    this.data.confirmButtonText = this.data.confirmButtonText ?? this.translate.instant('confirm');
    this.data.cancelButtonText = this.data.cancelButtonText ?? this.translate.instant('cancel');
    this.data.confirmButton = this.data.confirmButton ?? 'warn-secondary';
    this.data.list = this.data.list ?? [];
    this.data.messages = this.data.messages ?? [];
    this.data.showAreYouSure = !!this.data.showAreYouSure;
  }

  get isChoiceInvalid(): boolean {
    return !!this.data.choiceControl && this.data.choiceControl.invalid;
  }

  ngOnInit(): void {
    this.dialogRef.updateSize(this.data.width ?? '30rem');
  }
}
